<template>
  <div class="Word-uploading">
    <div class="left" v-if="files && files.length">
      <div class="progress-area">
        <div class="file">
          <img src="@imgs/word.png" alt="" />
          <div class="name">{{ files[0].name }}</div>
        </div>
        <el-progress :percentage="files[0].percentage" color="rgba(223, 88, 19, 1)" :stroke-width="6" :show-text="false"></el-progress>
      </div>
      <div class="settings">
        <div class="style-map-and-article-split">
          <div class="style-map btn">样式映射</div>
          <div class="article-split">
            <span>文章拆分至：</span>
            <el-select size="mini" class="select" v-model="splitLevel">
              <el-option :key="0" label="1级" :value="1"></el-option>
              <el-option :key="1" label="2级" :value="2"></el-option>
              <el-option :key="2" label="3级" :value="3"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="produce" :class="{ disabled: uploadState !== 'singleWordUploadDone' }" @click="uploadHandler('singleWord')">
        生成电子书
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import setBook from '@api/setBook'
export default {
  name: 'singWordUploading',
  props: {
    uploadState: {
      default: ''
    },
    file: {
      default() {
        return {
          name: '测试'
        }
      }
    },
    pdfType: {
      default: 'book'
    }
  },
  data() {
    return {
      show: true,
      splitLevel: 1 //拆分级别
    }
  },
  computed: {
    ...mapState('config', {
      open: (state) => state.bookObj.open,
      dpi: (state) => state.bookObj.dpi,
      referer: (state) => state.bookObj.referer,
      displayPageNo: (state) => state.bookObj.displayPageNo
    }),
    files() {
      return this.$store.state.book.batchWordFiles
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    handleMove(type, index) {
      let currentValue = this.files[index]
      let displaceIndex = 0
      switch (type) {
        case 'first':
          if (index > 0) {
            this.files.splice(index, 1)
            this.files.unshift(currentValue)
          }
          break
        case 'last':
          if (index < this.files.length - 1) {
            this.files.splice(index, 1)
            this.files.push(currentValue)
          }
          break
        case 'previous':
          displaceIndex = index === 0 ? 0 : index - 1
          if (index !== displaceIndex) {
            this.$set(this.files, index, this.files[displaceIndex])
            this.$set(this.files, displaceIndex, currentValue)
          }
          break
        case 'next':
          displaceIndex = index === this.files.length - 1 ? this.files.length - 1 : index + 1
          if (index !== displaceIndex) {
            this.$set(this.files, index, this.files[displaceIndex])
            this.$set(this.files, displaceIndex, currentValue)
          }
          break
      }
    },
    // 批量batch 合并merge生成电子书
    uploadHandler(type) {
      if (this.uploadState !== 'singleWordUploadDone') {
        return
      }
      // const pdfType = (this.pdfType === 'paper' ? this.pdfType : '') + (this.replaceId ? 'Replace' : '')
      const currentApi = setBook['batchWordBook']
      let param = {
        ids: '', //是	String	pdf上传文件md5值串，中间用,隔开
        fileName: '', //是	String	排序第一位的电子书名
        dpi: this.dpi, //是	int	当前精度，默认180L
        open: this.open, //	是	int	公开展示。0-否，1-是，默认0
        referer: this.referer, //	是	int	页面展示参考页码，默认1
        displayPageNo: this.displayPageNo, //	是	int	展示范围，0-全部，大于0-指定页码，默认全部
        userName: this.userName,
        splitLevel: this.splitLevel
      }
      if (this.pdfType === 'paper') {
        param.baozhiId = this.paperType
      }
      this.files.forEach((item, index) => {
        if (index === 0) {
          param.ids = item.uuid
          param.fileName = item.name
        } else {
          param.ids += `,${item.uuid}`
        }
      })
      if (this.replaceId) {
        param.worksId = this.replaceId
      }

      currentApi(param)
        .then((res) => {
          if (res && res.data && res.status === 200 && (res.data.code === 0 || res.data.status === 0)) {
            console.log(res.data)
            this.$router.push({ name: 'list', params: { to: this.pdfType }, query: { sourceSite: 1 } })
          } else {
            this.$message({
              message: res.message || '上传失败',
              type: 'error'
            })
          }
        })
        .catch((err) => {
          this.$message({
            message: err.toString() || '上传失败',
            type: 'error'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.Word-uploading {
  width: 100%;
  height: calc(100% + 10px);
  margin-top: -10px;
  display: flex;
  border-radius: 8px;
  .right {
    width: 150px;
    border-left: dashed 1px #979797;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left {
    width: calc(100% - 151px);
    padding-top: 37px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .progress-area {
    height: 100%;
    flex: 1;
    width: 240px;
    margin: auto;
    .file {
      .name {
        font-size: 16px;
        line-height: 22px;
        margin: 10px auto;
      }
      .img {
        width: 32px;
      }
    }
  }
  .settings {
    margin: 15px;
    font-size: 14px;
    .style-map-and-article-split {
      display: flex;
      justify-content: space-between;
    }
    .btn {
      width: 92px;
      line-height: 28px;
      border: 1px solid rgba(223, 88, 19, 1);
      border-radius: 2px;
      color: rgba(223, 88, 19, 1);
      cursor: pointer;
    }
    .select {
      width: 100px;
    }
    .style-map {
      visibility: hidden;
    }
  }
  .produce {
    width: 100px;
    line-height: 32px;
    border-radius: 3px;
    background: rgba(250, 177, 94, 1);
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    &.disabled {
      background-color: #cecece;
      cursor: not-allowed;
    }
  }
}
</style>
